import { WmsService } from "../resource";
import swal from "sweetalert2";
import i18n from "./i18n";

const  WmsInventoryModule = {
  namespaced: true,
  state: {
    data: [],
    data_history: [],
    data_history_detail: [],
    keyword: "",
	data_storage: [],
	isLoading:false,
	summary_product: [],
	summary_storage: [],
	summary_packing: [],
	isLoading:false,
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    },
    SET_DATA_HISTORY (state, data) {
      state.data_history = data
    },
    SET_DATA_HISTORY_DETAIL (state, data) {
      state.data_history_detail = data
    },
    SET_DATA_STORAGE (state, data) {
      state.data_storage = data
    },
	SET_DATA_SUMMARY (state, data) {
	  state.summary_product = data.detail_by_product
	  state.summary_storage = data.detail_by_storage
	  state.summary_packing = data.detail_by_date_by_product == null ? [] : data.detail_by_date_by_product
	},
  },
  actions: {
    SearchInventory({state},keyword){
      state.keyword = keyword
    },
    InventoryIn ({ commit, state }, data) {
        return WmsService.InventoryIn(data)
    },
    InventoryOut ({ commit, state }, data) {
        return WmsService.InventoryOut(data)
    },
    InventoryTransfer ({ commit, state }, data) {
      return WmsService.InventoryTransfer(data)
    },
    InventoryTransferByUser ({ commit, state }, data) {
      return WmsService.InventoryTransferByUser(data)
    },
    InventoryMoveReturnToRetail ({ commit, state }, data) {
      return WmsService.InventoryMoveReturnToRetail(data)
    },
    // Pass-through: the modal owns this state, nothing is committed here.
    InventoryReturnBalance ({ commit, state }, data) {
      return WmsService.InventoryReturnBalance(data)
    },
    InventoryMoveReturnToMain ({ commit, state }, data) {
      return WmsService.InventoryMoveReturnToMain(data)
    },
    // #437 shipped-no-deduct report — pass-through, the page owns the state.
    getShippedNoDeduct (ctx, params) {
      return WmsService.getShippedNoDeduct(params)
    },
    InventoryDelete ({ commit, state }, data) {
        return WmsService.InventoryDelete(data)
    },
    
    async HistoryDetail ({ commit, state },param) {
		state.isLoading = true
			swal.fire({
				title: i18n.t(`processing`),
				type: "info",
				allowEscapeKey: false,
				allowOutsideClick: false,
				onOpen: () => {
					swal.showLoading();
				}
			  });
      try{
        const data = await WmsService.InventoryHistoryDetail(param)
        if (data.data == null) 
        {
          commit('SET_DATA_HISTORY_DETAIL', [])
        }
        else 
        {
          commit('SET_DATA_HISTORY_DETAIL', data.data)
        }
		swal.close()
		state.isLoading = false
      }
      catch(err)
      {
		swal.close()
		console.log(err);
		swal.fire({
		title: i18n.t(err.response.data.Msg),
		text: i18n.t(err.response.data.Cause),
		icon: "error",
		buttonsStyling: false,
		confirmButtonClass: "btn btn-info btn-fill"
		});
        commit('SET_DATA_HISTORY_DETAIL', [])
		state.isLoading = false
      }
    },
    async listHistory ({ commit, state },param) {
      state.keyword = ""
      try{
        const data = await WmsService.InventoryHistory(param)
        if (data.data.Data == null) 
        {
          commit('SET_DATA_HISTORY', [])
        }
        else 
        {
          commit('SET_DATA_HISTORY', data.data.Data)
        }
      }
      catch(err)
      {
      console.log(err)
        commit('SET_DATA_HISTORY', [])
      }
    },
    async listData ({ commit, state },params) {
      state.keyword = ""
      try{
        const data = await WmsService.InventoryList(params)
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch(err)
      {
      console.log(err)
        commit('SET_DATA', [])
      }
    },
	async listHistoryStorage ({ commit, state },params) {
		state.isLoading = true
		swal.fire({
			title: i18n.t(`processing`),
			type: "info",
			allowEscapeKey: false,
			allowOutsideClick: false,
			onOpen: () => {
				swal.showLoading();
			}
		  });
		try{
		  const data = await WmsService.InventoryListByStorage(params)
			commit('SET_DATA_STORAGE', data.data.Datum.histories == null ? [] : data.data.Datum.histories)
			commit('SET_DATA_SUMMARY', data.data.Datum.QuantitySummary)
			swal.close()
			state.isLoading = false
		}
		catch(err)
		{
		  console.log(err)
		  commit('SET_DATA_STORAGE', [])
		  commit('SET_DATA_SUMMARY', {detail_by_product:[],detail_by_storage:[],detail_by_date_by_product:[]})
		  state.isLoading = false
		  swal.fire({
		  title: i18n.t(err.response.data.Msg),
		  text: i18n.t(err.response.data.Cause),
		  icon: "error",
		  buttonsStyling: false,
		  confirmButtonClass: "btn btn-info btn-fill"
		  });
		}
	  },

	async listHistoryStorageV2 ({ commit, state },params) {
		state.isLoading = true
		swal.fire({
			title: i18n.t(`processing`),
			type: "info",
			allowEscapeKey: false,
			allowOutsideClick: false,
			onOpen: () => {
				swal.showLoading();
			}
		  });
		try{
		  const data = await WmsService.InventoryListByStorageV2(params)
			commit('SET_DATA_STORAGE', data.data.Datum.histories == null ? [] : data.data.Datum.histories)
			commit('SET_DATA_SUMMARY', data.data.Datum.QuantitySummary)
			swal.close()
			state.isLoading = false
		}
		catch(err)
		{
		  console.log(err)
		  commit('SET_DATA_STORAGE', [])
		  commit('SET_DATA_SUMMARY', {detail_by_product:[],detail_by_storage:[],detail_by_date_by_product:[]})
		  state.isLoading = false
		  swal.fire({
		  title: i18n.t(err.response.data.Msg),
		  text: i18n.t(err.response.data.Cause),
		  icon: "error",
		  buttonsStyling: false,
		  confirmButtonClass: "btn btn-info btn-fill"
		  });
		}
	  },
    
  },
  getters: {
    getData (state) {
      return state.data
    },
    getHistory (state) {
      return state.data_history
    },
    getHistoryHead (state) {

		if (state.data_history_detail.Head != null) {
			return state.data_history_detail.Head
		} else {
			return {
				"BillNumber": "",
				"Note": "",
				"UserName": "",
				"CreateAt": "",
				"BillImage": "",
			}
		}

    },
	getHistoryStorage (state) {
		return state.data_storage
	  },
    getHistoryDetail (state) {
      return state.data_history_detail.Data
    },
    getSearch(state){
      if (state.keyword != ""){

        return state.data.filter(item => (item.ProductName.indexOf(state.keyword) !== -1 || item.StorageName.indexOf(state.keyword) !== -1))

      } else {
        return state.data
      }
    },
    getInventoryName({state},id){
      let n =  state.data.filter( d => d.ID === id)[0]
      return n.StorageName + " - " + n.ProductName
    },
	getSummaryByStorage(state){
		return state.summary_storage
	},
	getSummaryByProduct(state){
		return state.summary_product
	},
	getSummaryPacking(state){
		let table = []

		state.summary_packing.forEach(element => {
			let date = element.date
			// loop detail by product
			if (element.detail_by_product != null) {
				element.detail_by_product.forEach(product => {
					let row = {
						date: date,
						product_name: product.product_name,
						amount_packing: product.amount_packing
					}
					table.push(row)
				})
			}
		});
		return table
	}

  }
}

export default WmsInventoryModule
